import { ExpressionModel } from "./ExpressionModel";


export function getExpressionType(expression: ExpressionModel | undefined): string | undefined {
    if (!expression) {
        return undefined;
    }
    return expression.Type ?? Object.keys(expression)[0];
}
